import * as SentryWeb from "@sentry/react"

type InitOptions = Record<string, any>

export const init = (options: InitOptions = {}): void => {
  const integrations = [SentryWeb.replayIntegration({
    // allow images, videos, etc to be captured in replays
    blockAllMedia: false,
  })]

  SentryWeb.init({
    ...options,
    integrations,
  })
}

export const ErrorBoundary = SentryWeb.ErrorBoundary

export const wrap = (component: any): any => {
  const withProfiler = (SentryWeb as any).withProfiler
  return typeof withProfiler === 'function' ? withProfiler(component) : component
}

export const setUser = SentryWeb.setUser
export const setTag = SentryWeb.setTag
export const captureException = SentryWeb.captureException
export const captureMessage = SentryWeb.captureMessage

export default {
  init,
  ErrorBoundary,
  wrap,
  setUser,
  setTag,
  captureException,
  captureMessage,
}


